import '../src/assets/css/main.css';
import '../src/assets/css/style.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Nav from './componants/nav/nav';
import HomePage from './componants/home/home';
import TermsPage from './componants/terms/terms';
import PrivacyPage from './componants/privacy/privacy';
import Footer from './componants/footer/footer';
import ScrollToTop from './componants/scrollTop';
import Delete from './componants/delete/delete';

const path = "/neethusapp";

function App() {
    return (
        <Router>
            <div className="App">
                <Nav />
                <ScrollToTop />
                <Routes>
                    <Route path={`${path}`} element={<HomePage />} />
                    <Route path={`${path}/terms`} element={<TermsPage />} />
                    <Route path={`${path}/privacy`} element={<PrivacyPage />} />
                    <Route path={`${path}/delete`} element={<Delete />} />
                </Routes>
                <Footer />
            </div>
        </Router>
    );
}

export default App;
